import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import Role from "models/role"
import Screen from "models/screen"
import ScreenRole from "models/screen-role"

export interface AdminRolesSliceState {
    roles: Role[],
    showAddRoleModal: boolean,
    focusedRole: Role | null,
    assignedScreens: Screen[]
    savingScreens: boolean
    isDeletingRole: boolean
}

export const initialState: AdminRolesSliceState = {
    roles: [],
    showAddRoleModal: false,
    focusedRole: null,
    assignedScreens: [],
    savingScreens: false,
    isDeletingRole: false
}

const adminRolesSlice = createSlice({
    name: 'admin-roles',
    initialState,
    reducers: {
        setRoles(state, { payload }: PayloadAction<Role[]>) {
            state.roles = payload
        },
        setShowAddRoleModal(state, { payload }: PayloadAction<boolean>) {
            state.showAddRoleModal = payload
        },
        appendRole(state, { payload }: PayloadAction<Role>) {
            state.roles = [payload, ...state.roles]
        },
        setFoucusedRole(state, { payload }: PayloadAction<Role | null>) {
            state.focusedRole = payload
        },
        appendToAssignedScreens(state, { payload }: PayloadAction<Screen>) {
            state.assignedScreens = [...state.assignedScreens, payload]
        },
        removeFromAssignedScreens(state, { payload }: PayloadAction<Screen>) {
            state.assignedScreens = state.assignedScreens.filter(aS => aS.id !== payload.id)
        },
        setAssignedScreens(state, { payload }: PayloadAction<Screen[]>) {
            state.assignedScreens = payload
        },
        setSavingScreens(state, { payload }: PayloadAction<boolean>) {
            state.savingScreens = payload
        },
        setRoleScreens(state, { payload }: PayloadAction<{
            role: Role,
            screens: Screen[]
        }>) {
            const { role, screens } = payload;
            // Find role in role list
            const index = state.roles.findIndex(r => r.id === role.id);

            if (index === -1) return

            const foundRole = state.roles[index];
            const screenRoles: ScreenRole[] = screens.map((s: Screen) => ({
                screenId: s.id,
                roleId: foundRole.id,
                screen: s,
                role
            } as ScreenRole))

            foundRole.screenRoles = screenRoles;

            state.roles[index] = foundRole;
        },
        setIsDeleteRoles(state, { payload }: PayloadAction<boolean>) {
            state.isDeletingRole = payload
        },
        removeRole(state, { payload }: PayloadAction<Role>) {
            state.roles = state.roles.filter(r => r.id !== payload.id)
        }

    }
})

export default adminRolesSlice.reducer

export const {
    setRoles,
    setShowAddRoleModal,
    appendRole,
    setFoucusedRole,
    appendToAssignedScreens,
    removeFromAssignedScreens,
    setAssignedScreens,
    setSavingScreens,
    setRoleScreens,
    setIsDeleteRoles,
    removeRole
} = adminRolesSlice.actions
